import React from 'react';
import {Card} from "../../../../components/card/card.jsx";
import {FaArrowLeft, FaTrash} from "react-icons/fa";
import projectUtils from "../../../../utils/project-utils.js";
import AlertMessages from "../../../../components/messages/alert-message.js";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import myUserService from "../../../../services/web/my-user-service.js";
import {toast} from "react-toastify";

const MySwal = withReactContent(Swal);

const MyUserTrustedDevices = ({devices, setTarget, refetch}) => {
    const removeDevice = (deviceId) => {
        MySwal.fire({
            title: "Atenção",
            showCancelButton: true,
            html: `
                Esta operação não pode ser desfeita!<br> 
                Deseja remover este dispositivo?
            `,
            confirmButtonText: "Sim",
            cancelButtonText: "Não",
            confirmButtonColor: '#063A6C',
            cancelButtonColor: '#e64942',
            reverseButtons: true
        }).then(({isConfirmed}) => {
            if (isConfirmed) {
                const formData = new FormData()
                formData.append("id", deviceId)

                myUserService.removeTrustedDevice(formData)
                    .then(() => {
                        toast.success("Removido com sucesso");
                        refetch();
                    })
                    .catch(error => {
                        console.error(error);

                        const {message} = error.response.data;

                        let errMessage = AlertMessages[message] ?? "Não foi possível prosseguir.";
                        projectUtils.swalErrorMessage("", errMessage, "Ok");
                    });
            }
        });
    }

    return (
        <Card>
            <Card.Body>
                <h3 className="flex gap-2 items-center">
                <FaArrowLeft className="cursor-pointer font-normal" onClick={() => setTarget("info")}/>
                    Dispositivos confiáveis
                </h3>

                <div className="px-4 my-2 w-full">
                    {
                        !devices?.length &&
                        <div className="w-full text-center">
                            Nenhum dispositivo confiável
                        </div>
                    }

                    {
                        !!devices?.length &&
                        devices.sort((a, b) => new Date(b.lastLogin) - new Date(a.lastLogin)).map((device, index) => (
                            <div key={device.id}>
                                {index > 0 && <hr className={"text-[#bdbdbd]"}/>}
                                <h3>{device.info}</h3>
                                <div className="flex">
                                <span style={{width: "55%"}}>
                                    {device.os}
                                </span>
                                    <span style={{width: "30%"}}>
                                    Último acesso em {new Date(device.lastLogin).toLocaleString()}
                                </span>

                                    <span className="flex justify-end items-center" style={{width: "15%"}}>
                                    <FaTrash className={"cursor-pointer"} onClick={() => removeDevice(device.id)}/>
                                </span>
                                </div>
                            </div>
                        ))
                    }
                </div>
            </Card.Body>
        </Card>
    );
};

export default MyUserTrustedDevices;